import { useState } from "react";
import {
  Modal,
  Box,
  Button,
  Typography,
  Stack,
  useMediaQuery,
} from "@mui/material";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import FoundationOutlinedIcon from "@mui/icons-material/FoundationOutlined";

const MButtonModal = ({ planimetria, videoData }) => {
  const [open, setOpen] = useState(false);
  const [mediaType, setMediaType] = useState("image"); // "image" o "video"
  const [mediaSrc, setMediaSrc] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0); // Per tenere traccia dell'elemento corrente
  const isMobile = useMediaQuery("(max-width: 768px)");

  const mediaList = [
    ...(planimetria ? planimetria : []), // Aggiungi tutte le immagini della planimetria
    ...(videoData ? [videoData] : []), // Aggiungi il video (se presente)
  ];

  const handleOpen = (src, type, index) => {
    setMediaSrc(src);
    setMediaType(type);
    setCurrentIndex(index); // Imposta l'indice dell'elemento che stai visualizzando
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handleNext = () => {
    const nextIndex = (currentIndex + 1) % mediaList.length;
    setMediaSrc(mediaList[nextIndex]);
    setCurrentIndex(nextIndex);
  };

  const handlePrevious = () => {
    const prevIndex = (currentIndex - 1 + mediaList.length) % mediaList.length;
    setMediaSrc(mediaList[prevIndex]);
    setCurrentIndex(prevIndex);
  };

  return (
    <>
      <Stack
        flexDirection={"row"}
        width={"30%"}
        sx={{ borderRadius: "8px", padding: "2% 1%" }}
        justifyContent={"space-between"}
      >
        {/* Bottone Planimetria */}
        {planimetria && planimetria.length > 0 && (
          <Box margin={1}>
            <Button
              onClick={() => handleOpen(planimetria[0], "image", 0)}
              sx={{
                width: "120px",
                display: "flex",
                flexDirection: "column",
                borderRadius: "15px",
                background: "#ffffff",
                boxShadow: "5px 5px 10px #8b8b8b, -5px -5px 10px #ffffff",
              }}
            >
              <FoundationOutlinedIcon sx={{ color: "#166fce" }} />
              <Typography sx={{ color: "#166fce" }}>Planimetria</Typography>
            </Button>
          </Box>
        )}

        {/* Bottone Video */}
        {videoData && (
          <Box margin={1}>
            <Button
              onClick={() =>
                handleOpen(videoData, "video", planimetria?.length || 0)
              }
              sx={{
                width: "120px",
                display: "flex",
                flexDirection: "column",
                borderRadius: "15px",
                background: "#ffffff",
                boxShadow: "5px 5px 10px #8b8b8b, -5px -5px 10px #ffffff",
              }}
            >
              <VideocamOutlinedIcon sx={{ color: "#166fce" }} />
              <Typography sx={{ color: "#166fce" }}>Video</Typography>
            </Button>
          </Box>
        )}
      </Stack>

      {/* MODAL */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "60vw",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "8px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" sx={{ mb: 2 }}>
            Anteprima
          </Typography>

          {mediaType === "image" ? (
            <img
              src={mediaSrc}
              alt="Anteprima"
              style={{
                width: "100%",
                height: "100%",
                maxHeight: "600px",
                borderRadius: "8px",
                objectFit: "contain",
              }}
            />
          ) : (
            <video
              src={mediaSrc}
              controls
              style={{ width: "100%", borderRadius: "8px" }}
            />
          )}

          {/* Bottoni per navigare tra le immagini */}
          {mediaList.length > 1 && (
            <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
              <Button
                onClick={handlePrevious}
                variant="contained"
                color="secondary"
              >
                Precedente
              </Button>
              <Button
                onClick={handleNext}
                variant="contained"
                color="secondary"
              >
                Successivo
              </Button>
            </Stack>
          )}

          <Button
            onClick={handleClose}
            sx={{ mt: 2 }}
            variant="contained"
            color="primary"
          >
            Chiudi
          </Button>
        </Box>
      </Modal>
    </>
  );
};

export default MButtonModal;
